import type {
  ModuleCatalogEntryResponse,
  UpdateModuleCommercialInfoRequest,
} from '@tabita/contracts';
import { apiRequest } from './api-client';

/** Platform-operator endpoints — gated on `platform.module.*`, not a tenant resource. */
export const moduleCatalogApi = {
  list(): Promise<readonly ModuleCatalogEntryResponse[]> {
    return apiRequest<readonly ModuleCatalogEntryResponse[]>('/platform/modules');
  },

  update(
    key: string,
    body: UpdateModuleCommercialInfoRequest,
  ): Promise<ModuleCatalogEntryResponse> {
    return apiRequest<ModuleCatalogEntryResponse>(`/platform/modules/${key}`, {
      method: 'PUT',
      body,
    });
  },
};
